import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, change as onChange } from 'redux-form';

import {
  SelectInput,
} from 'admin-on-rest';

import ReferenceInput from './inputs/ReferenceInput';

export class PageReferenceFilter extends React.Component {
  componentWillReceiveProps = (nextProps) => {
    if (this.props.record.bookId !== nextProps.record.bookId) {
      nextProps.change('record-form', 'chapterId', null);
    }
  }

  render() {
    const { bookId } = this.props.record;
    return (
      <ReferenceInput {...this.props} label={this.props.label} source="chapterId" reference="chapters" filter={{ bookId }}>
        <SelectInput optionText="title" />
      </ReferenceInput>
    );
  }
}

const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state) }), { change: onChange }
)(PageReferenceFilter);
